import { render } from "./test.vue?vue&type=template&id=070bfb2f&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=070bfb2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1b9778f7109bb3d60df46d4c8243c5fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070bfb2f"]])

export default __exports__